import { ImageRequest } from "../../../../models";
import { EffectiveServiceDuration, ImageModel, ServiceModel } from "../../../entities";
import { BaseDataRepository } from "../../BaseDataRepository";
export class ServiceRepo extends BaseDataRepository<ServiceModel> {
  protected baseUrl = 'service';

  async insertImage(item: ImageRequest): Promise<ImageModel> {
    const response = await this.client.post(`${this.baseUrl}/${item.id}/image`, item.image);
    return this.handleResponse<ImageModel>(response)!;
  }

  async deleteImage(id: number): Promise<boolean> {
    const response = await this.client.delete(`${this.baseUrl}/${id}/image`);
    return this.handleResponse<boolean>(response)!;
  }

  async getEffectiveServiceDurationAsync(locationId: number, providerId: number): Promise<EffectiveServiceDuration[]>{
    const response = await this.client.get(`${this.baseUrl}/getEffectiveServiceDuration/location/${locationId}/provider/${providerId}`);
    return this.handleResponse<EffectiveServiceDuration[]>(response)!;
  }

}

export default ServiceRepo;
